import React, { useState } from "react";
import Swal from "sweetalert2";
import { ChevronDown, ChevronUp, GraduationCap, BookOpen } from "lucide-react";
import "./UniversityAccreditation.css";

const universities = [
  { name: "University of Ghana", content: "No accredited programme yet" },
  { name: "Kwame Nkrumah University of Science & Technology", content: "No accredited programme yet" },
  { name: "University of Coast", content: "No accredited programme yet" },
];

const UniversityAccreditation = () => {
  const [openSections, setOpenSections] = useState({});

  const toggleSection = (index) => {
    setOpenSections((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

    const handleDownloadPolicy = () => {
      Swal.fire({
        title: "Are you sure?",
        text: "You are about to download the University Accreditation Policy.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, download it!",
      }).then((result) => {
        if (result.isConfirmed) {
          const link = document.createElement("a");
          link.href = "/files/ASG Uni Accreditation Policy_v4_Final.pdf"; 
          link.download = "ASG Uni Accreditation Policy_v4_Final.pdf"; 
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    };

  return (
    <div>
        <section className="section-council">
        <div className="sectiontop-line"></div>
        <h2 className="sectiontitle">ACCREDITED UNIVERSITIES</h2>
        <div className="sectionbottom-line"></div>
        </section>
        <div className="main-container">
      <section className="university-section">
        <h2 className="uni-accreditation-title">University Accreditation</h2>
        <p>
          The ASG university accreditation managed by the Education Committee with support from the Actuarial Society of South Africa (ASSA)
          is a rigorous process intended to streamline actuarial education across the country. Our accreditation programme ensures that
          universities offer a set of mandatory recommended actuarial courses consistent with the ASSA syllabus.
        </p>
        <p>
          The ASG Education Committee leverages best practices in assessment through university examination and independent assessments.
          ASG offers accreditation leading all 5 exemptions under Level 1 and Level 2 of the ASG Pathway:
        </p>
        <ul>
          <li>L1-PAS – Probability & Actuarial Statistics</li>
          <li>L1-AE – Actuarial Economics</li>
          <li>L1-ARF – Actuarial Financial Reporting</li>
          <li>L2-FM – Financial Mathematics</li>
          <li>L2-RSS – Risk & Survival Statistics</li>
        </ul>

        <h2>Accredited Universities</h2>
        {universities.map((uni, index) => (
          <div className="university-card" key={index}>
            <div className="university-header" onClick={() => toggleSection(index)}>
              <span>{uni.name}</span>
              {openSections[index] ? <ChevronUp /> : <ChevronDown />}
            </div>
            {openSections[index] && <div className="university-content">{uni.content}</div>}
          </div>
        ))}
      </section>

      <section className="card-section">
      <div className="accreditation-card">
          <h1 className="uni-title">Exemption </h1>
        </div>

        <div className="accreditation-card" onClick={handleDownloadPolicy} style={{ cursor: "pointer" }}>
           <GraduationCap className="uni-icon" />
            <h1 className="uni-title">University Accreditation Policy</h1>
        </div>

        <div className="accreditation-card exemption-card">
          <BookOpen className="uni-icon" />
          <h1 className="uni-title">Exemption Policy</h1>
        </div>
      </section>
    </div>
    </div>
  );
};

export default UniversityAccreditation;
